import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from "vue";
import QR from "qrcode";


export default /*#__PURE__*/_defineComponent({
  __name: 'UiQrcode',
  props: {
  value: { default: "" },
  width: { type: Number, default: 196 },
  options: Object,
},
  setup(__props) {

const props = __props



const qrcode = ref<HTMLCanvasElement>();

onMounted(() => generate());

watch(
  () => props.value,
  () => generate()
);

watch(
  () => props.width,
  () => generate()
);

function generate() {
  if (!props.value) return;

  QR.toCanvas(qrcode.value, props.value, {
    width: props.width,
    ...props.options,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("canvas", {
    ref_key: "qrcode",
    ref: qrcode,
    class: "qrcode"
  }, null, 512))
}
}

})